module.exports = __webpack_public_path__ + "img/contact02.c5ee9f3f.png";